/**
 * Dictionnaires de noms fictifs pour le mode démo.
 *
 * Module PUR (aucune dépendance) — copié tel quel dans la codebase mobile
 * (WellfareMonitor2). Toute modification ici doit être répercutée côté mobile.
 *
 * Les listes localisées portent leurs variantes {fr, en, de} au même index :
 * le picking par hash est stable, la langue ne choisit que la variante.
 */

export const ANIMAL_NAMES = [
  "Simba", "Nala", "Luna", "Rocky", "Maya", "Tico", "Zara", "Bongo",
  "Kiara", "Django", "Pablo", "Chico", "Lola", "Max", "Ruby", "Oscar",
  "Bella", "Charlie", "Daisy", "Felix", "Gaïa", "Hugo", "Iris", "Jasper",
  "Kali", "Leo", "Mango", "Nino", "Olga", "Pepper", "Quincy", "Rio",
  "Sasha", "Toby", "Uma", "Vasco", "Willow", "Xena", "Yuma", "Zoé",
  "Aki", "Balou", "Cléo", "Dario", "Echo", "Fanta", "Gustav", "Hopi",
  "Inca", "Jengo", "Kito", "Lissa", "Moka", "Nayla", "Otto", "Paco",
  "Quilla", "Raja", "Suki", "Tamu", "Ulan", "Vega", "Wanda", "Yara",
  "Zuri", "Amber", "Bruno", "Coco", "Dune", "Elia", "Fidji", "Goliath",
  "Hina", "Idris", "Jade", "Kenzo", "Laïka", "Milo", "Noor", "Opale",
  "Pixel", "Quito", "Rosa", "Sam", "Tara", "Ulys", "Vicky", "Wapi",
  "Xali", "Yoko", "Zeus", "Anouk", "Basil", "Chaï", "Diego", "Elfie",
  "Farah", "Gino", "Haïku", "Ivo", "Juno", "Kaya",
];

export const FIRST_NAMES = [
  "Léa", "Hugo", "Emma", "Lucas", "Chloé", "Nathan", "Manon", "Louis",
  "Camille", "Jules", "Sarah", "Tom", "Julie", "Théo", "Laura", "Maxime",
  "Alice", "Antoine", "Clara", "Romain", "Élise", "Paul", "Nina", "Adam",
  "Éva", "Simon", "Zoé", "Victor", "Lucie", "Gabriel", "Anna", "Arthur",
  "Marie", "Ethan", "Jeanne", "Noah", "Inès", "Liam", "Rose", "Nolan",
  "Margot", "Sacha", "Louise", "Rafael", "Célia", "Milan", "Agathe", "Evan",
  "Mathilde", "Axel", "Salomé", "Robin", "Lily", "Marius", "Elena", "Oscar",
  "Maëlle", "Félix", "Ambre", "Timothée",
];

export const LAST_NAMES = [
  "Martin", "Bernard", "Dubois", "Thomas", "Robert", "Richard", "Petit",
  "Durand", "Leroy", "Moreau", "Simon", "Laurent", "Lefebvre", "Michel",
  "Garcia", "David", "Bertrand", "Roux", "Vincent", "Fournier", "Morel",
  "Girard", "André", "Lefèvre", "Mercier", "Dupont", "Lambert", "Bonnet",
  "François", "Martinez", "Legrand", "Garnier", "Faure", "Rousseau", "Blanc",
  "Guérin", "Muller", "Henry", "Roussel", "Nicolas", "Perrin", "Morin",
  "Mathieu", "Clément", "Gauthier", "Dumont", "Lopez", "Fontaine",
  "Chevalier", "Robin", "Masson", "Sanchez", "Gérard", "Nguyen", "Boyer",
  "Denis", "Lemaire", "Duval", "Joly", "Gautier",
];

export const ENCLOSURE_NAMES = [
  { fr: "Plaine africaine", en: "African Plains", de: "Afrikanische Savanne" },
  { fr: "Vallée des lions", en: "Lion Valley", de: "Löwental" },
  { fr: "Forêt des primates", en: "Primate Forest", de: "Primatenwald" },
  { fr: "Lagune des flamants", en: "Flamingo Lagoon", de: "Flamingo-Lagune" },
  { fr: "Territoire des loups", en: "Wolf Territory", de: "Wolfsrevier" },
  { fr: "Île aux lémuriens", en: "Lemur Island", de: "Lemureninsel" },
  { fr: "Bassin des otaries", en: "Sea Lion Pool", de: "Seelöwenbecken" },
  { fr: "Serre tropicale", en: "Tropical House", de: "Tropenhaus" },
  { fr: "Volière des rapaces", en: "Raptor Aviary", de: "Greifvogelvoliere" },
  { fr: "Plateau des girafes", en: "Giraffe Plateau", de: "Giraffenplateau" },
  { fr: "Clairière des cerfs", en: "Deer Glade", de: "Hirschlichtung" },
  { fr: "Marais des tapirs", en: "Tapir Marsh", de: "Tapirsumpf" },
  { fr: "Rocher des babouins", en: "Baboon Rock", de: "Pavianfelsen" },
  { fr: "Prairie des zèbres", en: "Zebra Meadow", de: "Zebrawiese" },
  { fr: "Canyon des pumas", en: "Puma Canyon", de: "Puma-Schlucht" },
  { fr: "Rivière des loutres", en: "Otter River", de: "Otterfluss" },
  { fr: "Dôme des oiseaux", en: "Bird Dome", de: "Vogelkuppel" },
  { fr: "Sentier des pandas roux", en: "Red Panda Trail", de: "Rote-Panda-Pfad" },
  { fr: "Steppe mongole", en: "Mongolian Steppe", de: "Mongolische Steppe" },
  { fr: "Baie des manchots", en: "Penguin Bay", de: "Pinguinbucht" },
  { fr: "Terre des ours", en: "Bear Country", de: "Bärenland" },
  { fr: "Jungle des tigres", en: "Tiger Jungle", de: "Tigerdschungel" },
  { fr: "Colline des suricates", en: "Meerkat Hill", de: "Erdmännchenhügel" },
  { fr: "Enclos des éléphants", en: "Elephant Paddock", de: "Elefantengehege" },
  { fr: "Refuge des koalas", en: "Koala Retreat", de: "Koala-Refugium" },
  { fr: "Vivarium des reptiles", en: "Reptile House", de: "Reptilienhaus" },
  { fr: "Crique des pélicans", en: "Pelican Cove", de: "Pelikanbucht" },
  { fr: "Savane des rhinocéros", en: "Rhino Savanna", de: "Nashorn-Savanne" },
  { fr: "Bambouseraie", en: "Bamboo Grove", de: "Bambushain" },
  { fr: "Falaise des vautours", en: "Vulture Cliff", de: "Geierklippe" },
  { fr: "Pré des antilopes", en: "Antelope Field", de: "Antilopenweide" },
  { fr: "Grotte des chauves-souris", en: "Bat Cave", de: "Fledermaushöhle" },
  { fr: "Étang des castors", en: "Beaver Pond", de: "Biberteich" },
  { fr: "Plaine asiatique", en: "Asian Plains", de: "Asiatische Ebene" },
  { fr: "Maison des gorilles", en: "Gorilla House", de: "Gorillahaus" },
  { fr: "Vallon des kangourous", en: "Kangaroo Valley", de: "Känguru-Tal" },
  { fr: "Désert des fennecs", en: "Fennec Desert", de: "Fennek-Wüste" },
  { fr: "Torrent des ibis", en: "Ibis Creek", de: "Ibisbach" },
  { fr: "Pinède des lynx", en: "Lynx Pines", de: "Luchswald" },
  { fr: "Terrasse des tortues", en: "Tortoise Terrace", de: "Schildkrötenterrasse" },
  { fr: "Savane des gnous", en: "Wildebeest Savanna", de: "Gnu-Savanne" },
  { fr: "Plaine des bisons", en: "Bison Plains", de: "Bisonebene" },
  { fr: "Forêt des ouistitis", en: "Marmoset Forest", de: "Seidenäffchenwald" },
  { fr: "Volière amazonienne", en: "Amazon Aviary", de: "Amazonas-Voliere" },
  { fr: "Lac des cygnes noirs", en: "Black Swan Lake", de: "Schwarzschwanensee" },
  { fr: "Tanière des hyènes", en: "Hyena Den", de: "Hyänenbau" },
  { fr: "Plage des morses", en: "Walrus Beach", de: "Walross-Strand" },
  { fr: "Récif des requins", en: "Shark Reef", de: "Hairiff" },
  { fr: "Mangrove des crocodiles", en: "Crocodile Mangrove", de: "Krokodilmangrove" },
  { fr: "Butte des chiens de prairie", en: "Prairie Dog Mound", de: "Präriehund-Hügel" },
  { fr: "Cascade des hérons", en: "Heron Falls", de: "Reiherwasserfall" },
  { fr: "Clairière des okapis", en: "Okapi Glade", de: "Okapi-Lichtung" },
  { fr: "Halte des dromadaires", en: "Camel Yard", de: "Dromedar-Gehege" },
  { fr: "Prairie des alpagas", en: "Alpaca Meadow", de: "Alpakawiese" },
  { fr: "Nurserie des wallabies", en: "Wallaby Nursery", de: "Wallaby-Kinderstube" },
  { fr: "Roseraie des paons", en: "Peacock Garden", de: "Pfauengarten" },
  { fr: "Sous-bois des tamanoirs", en: "Anteater Grove", de: "Ameisenbär-Gehölz" },
  { fr: "Terrier des blaireaux", en: "Badger Sett", de: "Dachsbau" },
  { fr: "Plateau des mouflons", en: "Mouflon Plateau", de: "Mufflon-Plateau" },
  { fr: "Combe des marmottes", en: "Marmot Hollow", de: "Murmeltiermulde" },
  { fr: "Lisière des émeus", en: "Emu Range", de: "Emu-Weide" },
  { fr: "Palmeraie des gibbons", en: "Gibbon Palm Grove", de: "Gibbon-Palmenhain" },
  { fr: "Estuaire des lamantins", en: "Manatee Estuary", de: "Seekuh-Mündung" },
  { fr: "Banquise des ours blancs", en: "Polar Bear Ice Field", de: "Eisbären-Eisfeld" },
  { fr: "Colline des chèvres naines", en: "Pygmy Goat Hill", de: "Zwergziegenhügel" },
  { fr: "Verger des perroquets", en: "Parrot Orchard", de: "Papageien-Obstgarten" },
  { fr: "Ravin des ocelots", en: "Ocelot Ravine", de: "Ozelot-Schlucht" },
  { fr: "Serre aux papillons", en: "Butterfly House", de: "Schmetterlingshaus" },
  { fr: "Berge des capybaras", en: "Capybara Bank", de: "Capybara-Ufer" },
  { fr: "Allée des ratons laveurs", en: "Raccoon Alley", de: "Waschbären-Allee" },
  { fr: "Gorge des léopards", en: "Leopard Gorge", de: "Leopardenschlucht" },
  { fr: "Oasis des oryx", en: "Oryx Oasis", de: "Oryx-Oase" },
  { fr: "Ponton des cormorans", en: "Cormorant Pier", de: "Kormoran-Steg" },
  { fr: "Toundra des rennes", en: "Reindeer Tundra", de: "Rentier-Tundra" },
  { fr: "Cirque des bouquetins", en: "Ibex Cirque", de: "Steinbock-Kar" },
  { fr: "Mare aux grenouilles", en: "Frog Pond", de: "Froschteich" },
  { fr: "Pavillon des nocturnes", en: "Nocturnal House", de: "Nachttierhaus" },
  { fr: "Ferme pédagogique", en: "Petting Farm", de: "Streichelzoo" },
  { fr: "Aquarium des récifs", en: "Reef Aquarium", de: "Riffaquarium" },
  { fr: "Belvédère des condors", en: "Condor Lookout", de: "Kondor-Aussicht" },
  { fr: "Plaine des lamas", en: "Llama Plains", de: "Lama-Ebene" },
  { fr: "Bassin des phoques", en: "Seal Pool", de: "Robbenbecken" },
  { fr: "Enclos des tapirs", en: "Tapir Paddock", de: "Tapirgehege" },
  { fr: "Volière des toucans", en: "Toucan Aviary", de: "Tukan-Voliere" },
  { fr: "Forêt des lémuriens", en: "Lemur Forest", de: "Lemurenwald" },
  { fr: "Colline des chèvres", en: "Goat Hill", de: "Ziegenhügel" },
  { fr: "Rocher des manchots", en: "Penguin Rock", de: "Pinguinfelsen" },
  { fr: "Prairie des bisons", en: "Bison Meadow", de: "Bisonwiese" },
  { fr: "Ravin des panthères", en: "Panther Ravine", de: "Pantherschlucht" },
  { fr: "Mare aux flamants", en: "Flamingo Pond", de: "Flamingoteich" },
  { fr: "Vallée des guépards", en: "Cheetah Valley", de: "Gepardental" },
  { fr: "Île aux gibbons", en: "Gibbon Island", de: "Gibbon-Insel" },
  { fr: "Refuge des pandas", en: "Panda Refuge", de: "Panda-Refugium" },
  { fr: "Clairière des loups", en: "Wolf Glade", de: "Wolfslichtung" },
  { fr: "Plaine des autruches", en: "Ostrich Plains", de: "Straußenebene" },
  { fr: "Enclos des zèbres", en: "Zebra Paddock", de: "Zebragehege" },
  { fr: "Pavillon des reptiles", en: "Reptile Pavilion", de: "Reptilienpavillon" },
  { fr: "Forêt des okapis", en: "Okapi Forest", de: "Okapiwald" },
  { fr: "Bassin des hippopotames", en: "Hippo Pool", de: "Flusspferdbecken" },
  { fr: "Terrasse des suricates", en: "Meerkat Terrace", de: "Erdmännchenterrasse" },
  { fr: "Grotte des ours", en: "Bear Cave", de: "Bärenhöhle" },
  { fr: "Savane des girafes", en: "Giraffe Savanna", de: "Giraffensavanne" },
  { fr: "Volière des ibis", en: "Ibis Aviary", de: "Ibis-Voliere" },
  { fr: "Maison des tortues", en: "Tortoise House", de: "Schildkrötenhaus" },
  { fr: "Plaine des élands", en: "Eland Plains", de: "Elenantilopen-Ebene" },
  { fr: "Jardin des papillons", en: "Butterfly Garden", de: "Schmetterlingsgarten" },
  { fr: "Enclos des rhinocéros", en: "Rhino Paddock", de: "Nashorngehege" },
  { fr: "Colline des marmottes", en: "Marmot Hill", de: "Murmeltierhügel" },
  { fr: "Lagune des pélicans", en: "Pelican Lagoon", de: "Pelikanlagune" },
  { fr: "Forêt des tamarins", en: "Tamarin Forest", de: "Tamarinwald" },
  { fr: "Bassin des loutres", en: "Otter Pool", de: "Otterbecken" },
  { fr: "Plateau des yacks", en: "Yak Plateau", de: "Yak-Plateau" },
  { fr: "Ferme des alpagas", en: "Alpaca Farm", de: "Alpakafarm" },
  { fr: "Enclos des kangourous", en: "Kangaroo Paddock", de: "Kängurugehege" },
  { fr: "Volière des aras", en: "Macaw Aviary", de: "Ara-Voliere" },
  { fr: "Canyon des lycaons", en: "Wild Dog Canyon", de: "Wildhund-Schlucht" },
  { fr: "Clairière des cerfs du Père David", en: "Père David's Deer Glade", de: "Davidshirsch-Lichtung" },
  { fr: "Vivarium tropical", en: "Tropical Vivarium", de: "Tropenvivarium" },
  { fr: "Plaine des chevaux de Przewalski", en: "Przewalski's Horse Plains", de: "Przewalski-Pferde-Ebene" },
  { fr: "Loge de quarantaine", en: "Quarantine Quarters", de: "Quarantänestall" },
];

export const TOURNEE_NAMES = [
  { fr: "Tournée du matin", en: "Morning round", de: "Morgenrunde" },
  { fr: "Tournée du soir", en: "Evening round", de: "Abendrunde" },
  { fr: "Tournée nourrissage", en: "Feeding round", de: "Fütterungsrunde" },
  { fr: "Tournée sanitaire", en: "Health check round", de: "Gesundheitsrunde" },
  { fr: "Tournée des carnivores", en: "Carnivore round", de: "Raubtier-Runde" },
  { fr: "Tournée des volières", en: "Aviary round", de: "Volieren-Runde" },
  { fr: "Tournée secteur nord", en: "North sector round", de: "Runde Bereich Nord" },
  { fr: "Tournée secteur sud", en: "South sector round", de: "Runde Bereich Süd" },
  { fr: "Tournée d'ouverture", en: "Opening round", de: "Eröffnungsrunde" },
  { fr: "Tournée de fermeture", en: "Closing round", de: "Schlussrunde" },
  { fr: "Tournée enrichissements", en: "Enrichment round", de: "Enrichment-Runde" },
  { fr: "Tournée des primates", en: "Primate round", de: "Primaten-Runde" },
  { fr: "Tournée aquatique", en: "Aquatic round", de: "Wasser-Runde" },
  { fr: "Tournée de nuit", en: "Night round", de: "Nachtrunde" },
  { fr: "Tournée week-end", en: "Weekend round", de: "Wochenendrunde" },
  { fr: "Grande tournée", en: "Grand round", de: "Große Runde" },
  { fr: "Tournée du midi", en: "Midday round", de: "Mittagsrunde" },
  { fr: "Tournée des herbivores", en: "Herbivore round", de: "Pflanzenfresser-Runde" },
  { fr: "Tournée des reptiles", en: "Reptile round", de: "Reptilien-Runde" },
  { fr: "Tournée vétérinaire", en: "Veterinary round", de: "Tierarztrunde" },
  { fr: "Tournée secteur est", en: "East sector round", de: "Runde Bereich Ost" },
  { fr: "Tournée secteur ouest", en: "West sector round", de: "Runde Bereich West" },
  { fr: "Tournée de la ferme", en: "Farm round", de: "Bauernhof-Runde" },
  { fr: "Tournée des nocturnes", en: "Nocturnal round", de: "Nachttier-Runde" },
];

export const SECTOR_NAMES = [
  { fr: "Secteur Savane", en: "Savanna Sector", de: "Bereich Savanne" },
  { fr: "Secteur Tropical", en: "Tropical Sector", de: "Bereich Tropen" },
  { fr: "Secteur Nord", en: "North Sector", de: "Bereich Nord" },
  { fr: "Secteur Sud", en: "South Sector", de: "Bereich Süd" },
  { fr: "Secteur Primates", en: "Primate Sector", de: "Bereich Primaten" },
  { fr: "Secteur Oiseaux", en: "Bird Sector", de: "Bereich Vögel" },
  { fr: "Secteur Aquatique", en: "Aquatic Sector", de: "Bereich Wasser" },
  { fr: "Secteur Carnivores", en: "Carnivore Sector", de: "Bereich Raubtiere" },
  { fr: "Secteur Herbivores", en: "Herbivore Sector", de: "Bereich Pflanzenfresser" },
  { fr: "Secteur Asie", en: "Asia Sector", de: "Bereich Asien" },
  { fr: "Secteur Amérique", en: "Americas Sector", de: "Bereich Amerika" },
  { fr: "Secteur Australie", en: "Australia Sector", de: "Bereich Australien" },
  { fr: "Secteur Madagascar", en: "Madagascar Sector", de: "Bereich Madagaskar" },
  { fr: "Secteur Montagne", en: "Mountain Sector", de: "Bereich Gebirge" },
  { fr: "Secteur Ferme", en: "Farm Sector", de: "Bereich Bauernhof" },
  { fr: "Secteur Vivarium", en: "Vivarium Sector", de: "Bereich Vivarium" },
  { fr: "Secteur Afrique", en: "Africa Sector", de: "Bereich Afrika" },
  { fr: "Secteur Europe", en: "Europe Sector", de: "Bereich Europa" },
  { fr: "Secteur Est", en: "East Sector", de: "Bereich Ost" },
  { fr: "Secteur Ouest", en: "West Sector", de: "Bereich West" },
  { fr: "Secteur Central", en: "Central Sector", de: "Bereich Mitte" },
  { fr: "Secteur Plaines", en: "Plains Sector", de: "Bereich Ebenen" },
  { fr: "Secteur Forêt", en: "Forest Sector", de: "Bereich Wald" },
  { fr: "Secteur Rivière", en: "River Sector", de: "Bereich Fluss" },
  { fr: "Secteur Lac", en: "Lake Sector", de: "Bereich See" },
  { fr: "Secteur Collines", en: "Hills Sector", de: "Bereich Hügel" },
  { fr: "Secteur Désert", en: "Desert Sector", de: "Bereich Wüste" },
  { fr: "Secteur Jungle", en: "Jungle Sector", de: "Bereich Dschungel" },
  { fr: "Secteur Grands Félins", en: "Big Cats Sector", de: "Bereich Großkatzen" },
  { fr: "Secteur Ongulés", en: "Hoofstock Sector", de: "Bereich Huftiere" },
  { fr: "Secteur Reptiles", en: "Reptile Sector", de: "Bereich Reptilien" },
  { fr: "Secteur Nocturne", en: "Nocturnal Sector", de: "Bereich Nachttiere" },
  { fr: "Secteur Pédagogique", en: "Education Sector", de: "Bereich Pädagogik" },
  { fr: "Secteur Soins", en: "Animal Care Sector", de: "Bereich Tierpflege" },
  { fr: "Secteur Volières", en: "Aviary Sector", de: "Bereich Volieren" },
  { fr: "Secteur Marais", en: "Wetland Sector", de: "Bereich Feuchtgebiet" },
  { fr: "Secteur Vallée", en: "Valley Sector", de: "Bereich Tal" },
  { fr: "Secteur Canopée", en: "Canopy Sector", de: "Bereich Baumkronen" },
  { fr: "Secteur Arctique", en: "Arctic Sector", de: "Bereich Arktis" },
  { fr: "Secteur Océanie", en: "Oceania Sector", de: "Bereich Ozeanien" },
  { fr: "Secteur Himalaya", en: "Himalaya Sector", de: "Bereich Himalaya" },
  { fr: "Secteur Méditerranée", en: "Mediterranean Sector", de: "Bereich Mittelmeer" },
];

export const GROUP_NAMES = [
  { fr: "Groupe des femelles", en: "Female group", de: "Weibchengruppe" },
  { fr: "Groupe des mâles", en: "Male group", de: "Männchengruppe" },
  { fr: "Harde principale", en: "Main herd", de: "Haupt-Herde" },
  { fr: "Groupe des juvéniles", en: "Juvenile group", de: "Jungtiergruppe" },
  { fr: "Colonie du lac", en: "Lake colony", de: "Seekolonie" },
  { fr: "Meute du nord", en: "Northern pack", de: "Nordrudel" },
  { fr: "Troupe des hauteurs", en: "Highland troop", de: "Hochland-Gruppe" },
  { fr: "Groupe reproducteur", en: "Breeding group", de: "Zuchtgruppe" },
  { fr: "Bande des îles", en: "Island band", de: "Inselgruppe" },
  { fr: "Groupe des doyens", en: "Senior group", de: "Seniorengruppe" },
  { fr: "Clan de la rivière", en: "River clan", de: "Flussclan" },
  { fr: "Volée du dôme", en: "Dome flock", de: "Kuppelschwarm" },
  { fr: "Groupe familial", en: "Family group", de: "Familiengruppe" },
  { fr: "Groupe des aînées", en: "Elder females", de: "Ältere Weibchen" },
  { fr: "Couple reproducteur", en: "Breeding pair", de: "Zuchtpaar" },
  { fr: "Groupe de célibataires", en: "Bachelor group", de: "Junggesellengruppe" },
  { fr: "Troupe du plateau", en: "Plateau troop", de: "Plateau-Gruppe" },
  { fr: "Colonie de la falaise", en: "Cliff colony", de: "Klippenkolonie" },
  { fr: "Harde de la plaine", en: "Plains herd", de: "Ebenen-Herde" },
  { fr: "Meute du sud", en: "Southern pack", de: "Südrudel" },
  { fr: "Groupe mixte", en: "Mixed group", de: "Gemischte Gruppe" },
  { fr: "Groupe des nouveaux arrivants", en: "Newcomers group", de: "Neuankömmlinge" },
  { fr: "Groupe de la volière", en: "Aviary flock", de: "Volierenschwarm" },
  { fr: "Troupeau pédagogique", en: "Petting herd", de: "Streichelherde" },
  { fr: "Groupe d'observation", en: "Observation group", de: "Beobachtungsgruppe" },
  { fr: "Colonie nocturne", en: "Night colony", de: "Nachtkolonie" },
];

export const ZOO_NAMES = [
  { fr: "Parc zoologique de la Vallée", en: "Valley Zoological Park", de: "Zoologischer Park im Tal" },
  { fr: "Réserve des Grands Chênes", en: "Great Oaks Reserve", de: "Reservat Große Eichen" },
  { fr: "Parc animalier du Lac", en: "Lakeside Wildlife Park", de: "Tierpark am See" },
  { fr: "Jardin zoologique des Collines", en: "Hillside Zoo", de: "Zoo an den Hügeln" },
  { fr: "Parc de la Rivière Sauvage", en: "Wild River Park", de: "Wildfluss-Park" },
  { fr: "Domaine des Trois Forêts", en: "Three Forests Estate", de: "Drei-Wälder-Park" },
  { fr: "Parc animalier des Crêtes", en: "Ridgeway Wildlife Park", de: "Tierpark am Kamm" },
  { fr: "Zoo des Deux Rivières", en: "Two Rivers Zoo", de: "Zoo an zwei Flüssen" },
  { fr: "Réserve de la Vallée Verte", en: "Green Valley Reserve", de: "Reservat Grünes Tal" },
  { fr: "Parc zoologique des Marais", en: "Marshland Zoological Park", de: "Zoologischer Park im Moor" },
  { fr: "Jardin animalier du Plateau", en: "Plateau Animal Garden", de: "Tiergarten am Plateau" },
  { fr: "Parc des Cèdres", en: "Cedar Park Zoo", de: "Zedernpark-Zoo" },
  { fr: "Zoo de la Baie", en: "Bayside Zoo", de: "Zoo an der Bucht" },
  { fr: "Réserve des Hautes Terres", en: "Highlands Reserve", de: "Hochland-Reservat" },
  { fr: "Parc animalier du Moulin", en: "Old Mill Wildlife Park", de: "Tierpark an der Mühle" },
  { fr: "Domaine de la Forêt Claire", en: "Clearwood Estate", de: "Lichtwald-Anwesen" },
  { fr: "Zoo des Sources", en: "Springs Zoo", de: "Quellen-Zoo" },
  { fr: "Parc de l'Étang Bleu", en: "Blue Pond Park", de: "Blauteich-Park" },
  { fr: "Jardin zoologique du Littoral", en: "Coastal Zoological Garden", de: "Zoologischer Garten an der Küste" },
  { fr: "Parc des Grandes Prairies", en: "Great Prairies Park", de: "Park der Großen Prärien" },
];

export const ADDRESSES = [
  { fr: "12 route du Parc, 00000 Val-des-Chênes", en: "12 Park Road, Oakvale", de: "Parkstraße 12, Eichental" },
  { fr: "4 chemin des Étangs, 00000 Beaulieu", en: "4 Pond Lane, Fairhaven", de: "Teichweg 4, Schönau" },
  { fr: "27 avenue de la Réserve, 00000 Montclair", en: "27 Reserve Avenue, Clearmont", de: "Reservatsallee 27, Klarberg" },
  { fr: "8 allée des Grands Cèdres, 00000 Saint-Loup", en: "8 Great Cedars Walk, Wolfton", de: "Zedernallee 8, Wolfsheim" },
  { fr: "3 rue de la Volière, 00000 Rivebelle", en: "3 Aviary Street, Fairbank", de: "Volierenstraße 3, Schönufer" },
  { fr: "15 route des Collines, 00000 Pierrefonds", en: "15 Hills Road, Stonebridge", de: "Hügelstraße 15, Steinfurt" },
];

export const CLINIC_NAMES = [
  { fr: "Clinique vétérinaire du Parc", en: "Park Veterinary Clinic", de: "Tierklinik am Park" },
  { fr: "Cabinet vétérinaire des Étangs", en: "Lakeside Veterinary Practice", de: "Tierarztpraxis am Teich" },
  { fr: "Clinique des Grands Animaux", en: "Large Animal Clinic", de: "Großtierklinik" },
  { fr: "Centre vétérinaire de la Faune", en: "Wildlife Veterinary Centre", de: "Wildtier-Tierarztzentrum" },
];
